import { Group, List, Stack, Text } from '@mantine/core';
import { IconUsers } from '@tabler/icons-react';
import Card from 'components/Card';
import React from 'react';
import { ReviewApproval as ReviewApprovalData } from 'types/lcms/courses';
import SMEItem from './SMEItem';
import FacilitatorItem from '../courseCombineTNA/FacilitatorItem';

interface ReviewApprovalProps {
  data?: ReviewApprovalData;
}

const ReviewApproval: React.FC<ReviewApprovalProps> = ({ data }) => {
  return (
    <Card>
      <Stack gap={16}>
        <Group gap={8}>
          <IconUsers />
          <Text c={'dark'} fw={700}>
            Reviewer & Approval
          </Text>
        </Group>
        <Stack gap={0}>
          <Text c={'grey.5'} fw={600} fz={14}>
            Review by SME
          </Text>
          <Text fz={14} c={'dark'}>
            {data?.flagReviewSME ? 'Yes' : 'No'}
          </Text>
        </Stack>
        <Stack gap={0}>
          <Text c={'grey.5'} fw={600} fz={14}>
            Internal SME
          </Text>

          {data?.smeInternal && data?.smeInternal.length > 0 ? (
            <List withPadding>
              {data?.smeInternal.map((sme, index) => {
                if (!sme) return null;
                return (
                  <SMEItem
                    key={index}
                    linkURL={sme.linkURL || ''}
                    name={sme.binusianID === sme.name ? sme.binusianID : sme.name}
                  />
                );
              })}
            </List>
          ) : (
            '-'
          )}
        </Stack>
        <Stack gap={0}>
          <Text c={'grey.5'} fw={600} fz={14}>
            Enternal SME
          </Text>
          {data?.smeExternal && data?.smeExternal.length > 0 ? (
            <List withPadding>
              {data?.smeExternal.map((sme, index) => {
                if (!sme) return null;
                return <SMEItem key={index} linkURL={sme.linkURL || ''} name={sme.email ?? '-'} />;
              })}
            </List>
          ) : (
            '-'
          )}
        </Stack>
        <Stack gap={8}>
          <Text c={'grey.5'} fw={600} fz={14}>
            Approval
          </Text>
          {data?.picApproval && data?.picApproval.length > 0 ? (
            <Stack gap={4}>
              {data.picApproval
                ?.sort((a, b) => Number(a.approvalLevel) - Number(b.approvalLevel))
                .map((pic, index) => (
                  <FacilitatorItem
                    key={index}
                    onClick={() => {
                      window.open(pic.linkURL, '_blank');
                    }}
                    approvalLevel={pic.approvalLevel}
                    binusianId={pic.binusianID}
                    email={pic.email}
                    name={pic.name}
                  />
                ))}
            </Stack>
          ) : (
            '-'
          )}
        </Stack>
      </Stack>
    </Card>
  );
};

export default ReviewApproval;
